import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4bf274d3"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Opções", -1))
const _hoisted_2 = { class: "lista-opcoes" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ItemDeSelecao = _resolveComponent("ItemDeSelecao")!
  const _component_AdicionarSelecao = _resolveComponent("AdicionarSelecao")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_TransitionGroup, { name: "opcoes" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itensOrdenados, (selecao, indice) => {
            return (_openBlock(), _createBlock(_component_ItemDeSelecao, {
              key: selecao.getId().toString(),
              selecao: (selecao as SelecaoEditavel),
              ehPrimeiro: indice === 0,
              ehUltimo: indice === _ctx.itensOrdenados.length - 1,
              onEditar: _ctx.editar,
              onExcluir: _ctx.excluir,
              onDescer: _ctx.descer,
              onSubir: _ctx.subir
            }, null, 8, ["selecao", "ehPrimeiro", "ehUltimo", "onEditar", "onExcluir", "onDescer", "onSubir"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_AdicionarSelecao, {
      indice: _ctx.itensOrdenados.length,
      onAdicionarItem: _ctx.adicionarItem
    }, null, 8, ["indice", "onAdicionarItem"])
  ], 64))
}